import { Fragment, useEffect, useState } from "react";
import Select from "react-select";
import { useGroupsQuery } from "../../../services/groupApi";
import customStyles from "./SelectFeild";
import { signInUser } from "../../Utility/Auth";

const SelectCategoryGroup = ({ mg, handleOnchange }) => {
  const auth = signInUser();
  const aamarId = auth?.aamarId;
  const { data, isSuccess } = useGroupsQuery(aamarId);

  const [groupOptions, setGroupOptions] = useState([
    { value: null, label: "Select Group" },
  ]);
  const [selectedGroup, setSelectedGroup] = useState({
    value: null,
    label: "Select Group",
  });

  const onChange = (selected) => {
    if (selected && selected.value) {
      setSelectedGroup(selected);
      handleOnchange(selected.value);
    } else {
      setSelectedGroup({ value: null, label: "Select Group" });
      handleOnchange(null);
    }
  };

  useEffect(() => {
    if (data?.length > 0) {
      setGroupOptions([
        { value: null, label: "Select Group" },
        ...data.map((group) => ({
          value: group._id,
          label: group.name,
        })),
      ]);
    }
  }, [isSuccess, data]);

  useEffect(() => {
    const targetId = typeof mg === "object" ? mg?._id : mg;
    const group = data?.find((item) => String(item?._id) === String(targetId));

    if (group) {
      setSelectedGroup({
        value: group._id,
        label: group.name,
      });
    } else {
      setSelectedGroup({
        value: null,
        label: "Select Group",
      });
    }
  }, [mg, data]);

  return (
    <Fragment>
      <Select
        className="basic-single"
        classNamePrefix="select"
        isDisabled={false}
        isLoading={!data}
        isClearable={true}
        isSearchable={true}
        name="group"
        value={selectedGroup?.value ? selectedGroup : null}
        placeholder="Select Group"
        onChange={onChange}
        options={groupOptions}
        styles={customStyles}
      />
    </Fragment>
  );
};

export default SelectCategoryGroup;

